module.exports = __webpack_public_path__ + "static/media/PTAlogo.b5c96ffe.svg";